export const FINANCE_ADD_NON_BUDGET_FORM_FIELDS = [{
  type: 'text',
  name: 'file_number',
  label: 'No. Pengajuan',
  placeholder: 'Isi nomor pengajuan',
  disabled: true,
}, {
  type: 'date',
  name: 'date',
  label: 'Tanggal',
  placeholder: 'Pilih tanggal',
  disabled: true,
}, {
  type: 'textarea',
  name: 'description',
  label: 'Keterangan Kegiatan',
  placeholder: 'Isi keterangan kegiatan',
  full: true,
  required: true,
}];

export const NON_BUDGET_REQUIRED_FIELD = ['parameter_code'];

export const FINANCE_NON_BUDGET_TABLE_FIELDS = {
  label: [
    'No',
    'No. Pengajuan',
    'Kode Unit',
    'Tanggal',
    'Jumlah Pengajuan',
    'Status Pengajuan',
    '',
  ],
  value: [
    {},
    { type: 'string', attribute: 'file_number' },
    { type: 'string', attribute: 'school_unit[0].school_unit_code'},
    { type: 'date', attribute: 'date' },
    { type: 'string', attribute: 'description' },
    { type: 'number', attribute: 'total' },
  ],
};
